// Demo / dev hub data domain per region. Production resolves from location.origin
// (or appData.meta.url as a fallback), so prod URLs don't live here.
export const DEFAULT_DEMO_DATA_DOMAIN = 'https://hubsite.dev.cmspow.com'; // US is default

// CMS API base per env. Stage uses a `stage.` prefix on the prod host.
export const CMS_API_DEMO_DOMAIN = 'https://api.cms.dev.cmspow.com';
export const CMS_API_STAGE_DOMAIN = 'https://stage.api.cms.universalpictures.com';
export const CMS_API_PROD_DOMAIN = 'https://api.cms.universalpictures.com';
